import {TagProps} from 'antd/es/tag';
import {AccountFieldsFragment, Maybe} from 'api/generated';
import {StatusTag} from 'components/StatusTag';
import {getAccountSystemTags, getAccountTagColor} from 'lib/acountTagUtils';
import React from 'react';
import {Link} from 'react-router-dom';

type Props = {
  account?: Maybe<AccountFieldsFragment>;
};

export const AccountTag: React.FC<TagProps & {accountId: string}> = (props) => {
  return (
    <Link to={'/accounts?tags=' + props.children}>
      <StatusTag {...props} />
    </Link>
  );
};

export const AccountTags: React.FC<Props> = ({account}) => {
  if (!account || !account.tags) return null;
  return (
    <>
      {getAccountSystemTags(account).map((tag, index) => (
        <AccountTag key={index} color={getAccountTagColor(tag)} accountId={account.id}>
          {tag}
        </AccountTag>
      ))}
    </>
  );
};
